export interface ErrorProps {
  error: boolean | undefined;
  message: string | undefined;
}
export const FormError = ({ error, message }: ErrorProps) => (
  <div>{error && <small className="text-danger-500">{message}</small>}</div>
);
export { default as FormTextInput } from "./form-input";
export { default as FormEmailInput } from "./form-email";
export { default as FormDomainInput } from "./form-domain";
export { default as FormPasswordInput } from "./form-password-input";
export { default as FormFileInput } from "./form-file";
export { default as FormFilesUploadInput } from "./form-files";
// export { default as FormPhoneInput } from "./form-phone";
export { default as FormSelectInput } from "./form-select";
export { default as FormDateInput } from "./form-date";
export { default as FormDateInput2 } from "./form-date-2";
export { default as FormDateTimeInput } from "./form-datetime";
export { default as FormRadioInput } from "./form-radio";
export { default as FormNumberInput } from "./form-number";
export { default as FormMonthInput } from "./form-month";
export { default as FormTextareaInput } from "./form-textarea";
export { default as FormRichTextInput } from "./form-richtext";
export { default as FormWizard, type FormInput } from "./wizard";
export { default as FormMomentInput } from "./form-moment";
export { default as FormTimeInput } from "./form-time";
export { default as FormInternalInput } from "./form-internal-input";
export { default as FormExternalInput } from "./form-external-input";
export { default as FormSignatureInput } from "./form-signature";
